import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { getTotals } from '../api';

const Navbar = ({ onLogout, onRefresh }) => {
  const location = useLocation();
  const [requestCount, setRequestCount] = useState(0);
  const [conversionCount, setConversionCount] = useState(0);

  // Check if a given path matches the current location
  const isActive = (path) => location.pathname === path;

  // If the active link is clicked, trigger the refresh callback.
  const handleNavClick = (targetPath) => {
    if (isActive(targetPath)) {
      onRefresh();
    }
  };

  useEffect(() => {
    // Fetch today's totals for requests and conversions.
    const fetchTotals = async () => {
      try {
        const requestsData = await getTotals('requests');
        const conversionsData = await getTotals('conversions');
        setRequestCount(requestsData.total);
        setConversionCount(conversionsData.total);
      } catch (error) {
        console.error('Error fetching totals:', error);
      }
    };

    fetchTotals();
    const intervalId = setInterval(() => {
      fetchTotals();
    }, 5000);

    return () => clearInterval(intervalId);
  }, []);

  return (
    <nav className="navbar">
      <div className="nav-container">
        <div className="nav-links">
          <Link
            to="/"
            className={`nav-link ${isActive('/') ? 'active' : ''}`}
            onClick={() => handleNavClick('/')}
          >
            Requests ({requestCount})
          </Link>
          <Link
            to="/conversions"
            className={`nav-link ${isActive('/conversions') ? 'active' : ''}`}
            onClick={() => handleNavClick('/conversions')}
          >
            Conversions ({conversionCount})
          </Link>
          <Link
            to="/domains"
            className={`nav-link ${isActive('/domains') ? 'active' : ''}`}
            onClick={() => handleNavClick('/domains')}
          >
            Domains
          </Link>
        </div>
        <button onClick={onLogout} className="logout-button">
          <span>Logout</span>
        </button>
      </div>
    </nav>
  );
};

export default Navbar;
